import Modal from 'utils/packages/Modal';
const strings = {
    title: 'Check your date of birth',
    subtitle: "To see your credit score, you'll need to be between 18 and 120 years old. Please check the date you entered.",
    okay: 'Okay',
};
const CreditScoreInvalidAgeModal = {
    show: () => {
        Modal.showConfirmation({
            title: strings.title,
            subtitle: strings.subtitle,
            confirmButtonTitle: strings.okay,
        });
    },
};
export default CreditScoreInvalidAgeModal;
